import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

var config = require('../../config'),
    moment = require('moment-timezone'),
    mixpanel = require('mixpanel-browser');

var doMixpanel =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            mixpanel.init(config.mixpanel_token, {
              batch_requests: true
            });

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function doMixpanel() {
    return _ref.apply(this, arguments);
  };
}();

var doHotjar =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            (function (h, o, t, j, a, r) {
              h.hj = h.hj || function () {
                (h.hj.q = h.hj.q || []).push(arguments);
              };

              h._hjSettings = {
                hjid: 1898124,
                hjsv: 6
              };
              a = o.getElementsByTagName('head')[0];
              r = o.createElement('script');
              r.async = 1;
              r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
              a.appendChild(r);
            })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function doHotjar() {
    return _ref2.apply(this, arguments);
  };
}();

angular.module('MainController', []).controller('MainController', ["$scope", "$cookies", "BASE_URL", "CALENDAR_URL", "ADMIN_URL", "API_URL", "ORGANISATION", "$http", "$window", "$rootScope", "$sce", function ($scope, $cookies, BASE_URL, CALENDAR_URL, ADMIN_URL, API_URL, ORGANISATION, $http, $window, $rootScope, $sce) {
  $scope.base_url = BASE_URL;
  $scope.calendar_url = CALENDAR_URL;
  $scope.appVersion = process.env.VERSION;
  $scope.organisation = ORGANISATION;
  $scope.shiftsLength = 1; // don't show no shifts message by default

  var notificationsRetrieved = false;
  $rootScope.$watch('userInfo', function () {
    if ($rootScope.userInfo && $rootScope.userInfo.orgid) {
      $scope.orgid = $rootScope.userInfo.orgid._id ? $rootScope.userInfo.orgid._id : $rootScope.userInfo.orgid;
      $scope.userRole = $rootScope.userInfo.roles[0].type;
      $scope.userFirstName = $rootScope.userInfo.firstname;

      try {
        var subscription = $rootScope.userInfo.subscription;
        $scope.paidSubscriber = subscription && subscription.id !== 'FOREVER_FREE';

        if (!$rootScope.analyticsInitialised && moment($rootScope.userInfo.createdAt).isAfter(moment('2020-08-05'))) {
          doHotjar();
          doMixpanel();
          $rootScope.analyticsInitialised = true;
        }

        if (subscription && subscription.on_trial) {
          $scope.subscriptionOnTrial = true;
          var secondsLeft = moment(subscription.expires_utc).unix() - moment().unix();
          $scope.subscriptionDaysLeft = parseInt(secondsLeft / 86400);
        }
      } catch (err) {
        console.error(err.message);
      }

      !notificationsRetrieved && getNotifications();
    }
  });

  var getNotifications = function getNotifications() {
    notificationsRetrieved = true; // Get notifications

    $http.get(API_URL + '/api/v1/notifications').then(function (reply) {
      if (!reply.data.notifications || !reply.data.notifications.length) $scope.notifications = [];
      $scope.notifications = reply.data.notifications.map(function (notification) {
        return _objectSpread({}, notification, {
          html: $sce.trustAsHtml(notification.html)
        });
      });
      $scope.notesToRead = reply.data.notifications.filter(function (note) {
        return !note.read;
      });
      $rootScope.userSurvey = reply.data.survey;
    }).catch(function (error) {
      console.error("Error retrieving notifications: ".concat(error));
    });
  };

  $scope.openNotifications = function () {
    $http.put(API_URL + '/api/v1/notifications/notesread').then(function (reply) {
      if (!reply.data.notifications || !reply.data.notifications.length) $scope.notifications = [];
      $scope.notesToRead = reply.data.notifications.filter(function (note) {
        return !note.read;
      });
      $scope.notifications = reply.data.notifications.map(function (notification) {
        return _objectSpread({}, notification, {
          html: $sce.trustAsHtml(notification.html)
        });
      });
    }).catch(function (error) {
      console.error("Error retrieving notifications: ".concat(error));
    });
  };

  $scope.logOut = function () {
    $rootScope.orgNeedsSetup = false;
    $rootScope.userInfo = null; // Delete jwt token from local storage and from cookie,
    // redirect to the login page.

    localStorage.removeItem('jwt-token');
    $cookies.remove('x-access-token');
    $window.location.href = ADMIN_URL + '/#/login';
  };
}]);